const DESIGN_CONSTANT = {
    formContentWidth: '1000px',
};

export default DESIGN_CONSTANT;
